// DISABLE-FLOW
export const AUTO_RENEWAL_FLOW_PAGE_ONE = {
  flow_slug: 'AutoRenewalFlagFlow',
  flow_version: 1,
  uuid: 'disable-rf-page-one',
  heading: 'Manage what happens at renewal',
  subtext: '',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Continue'
  },
  sections: [
    { uuid: 'reminder-on-section-page-1',
      subtext: '',
      layout: '',
      settings: {},
      heading: '',
      info: {
        content: '<h3>Your policy is set to automatically renew</h3></br><p style="font-weight: normal">This means that we’ll automatically renew your policy on your renewal date, if we are able to offer you renewal.</p>',
        type: 'success'
      },
      show_if: {
        operands: [
          '<renewal_flag>',
          [
            'CE',
            'AR'
          ]
        ],
        operator: 'in'
      },
    },
    {
      uuid: 'reminder-off-section-page-1',
      subtext: '',
      layout: '',
      settings: {},
      heading: '',
      info: {
        content: '<h3>Your renewal has been switched off</h3></br><p style="font-weight: normal">Turning your renewal off means your policy won\'t renew and you won\'t be covered after your policy expires.</p>',
        type: 'warning'
      },
      show_if: {
        operands: [
          '<renewal_flag>',
          'CD',
        ],
        operator: 'eq'
      },
    },
    {
      uuid: "confirmation-off-cycle",
      heading: "Would you like to change this setting?",
      subtext: "",
      layout: "",
      settings: {
        align: 'center'
      },
      show_if: {
        operands: [
          '<renewal_flag>',
          [
            'CE',
            'AR'
          ]
        ],
        operator: 'in'
      },
      elements: [
        {
          uuid: 'choices-off-cycle',
          subtext: '',
          layout: 'radio_tile',
          settings: {
            size: 'large',
            choices: [
              {
                label: 'Turn off auto-renew',
                value: true
              },
              {
                label: 'Return to my dashboard',
                value: false
              }
            ],
          },
          prompt: '',
          key: 'confirmationOff',
          type: 'choice',
          required: false
        }
      ]
    },
    {
      uuid: "confirmation-on-cycle",
      heading: "Would you like to change this setting?",
      subtext: "",
      layout: "",
      settings: {
        align: 'center'
      },
      show_if: {
        operands: [
          '<renewal_flag>',
            'CD'
        ],
        operator: 'eq'
      },
      elements: [
        {
          uuid: 'choices-on-cycle',
          subtext: '',
          layout: 'radio_tile',
          settings: {
            size: 'large',
            choices: [
              {
                label: 'Turn on auto-renew',
                value: true
              },
              {
                label: 'Return to my dashboard',
                value: false
              }
            ],
          },
          prompt: '',
          key: 'confirmationOn',
          type: 'choice',
          required: false
        }
      ]
    }
  ],
  data: {
    _flow_metadata: { current_page_uuid: 'disable-rf-page-one' },
  },
  human: {},
  actions: {
    back: {}
  },
  progress: 1,
  total_pages: 2,
  analytics: {
    flow_slug: 'disableRenewalFlow',
    flow_version: 1,
    page_uuid: 'disable-rf-page-one'
  }
};

export const AUTO_RENEWAL_FLOW_SUCCESS_PAGE = {
  flow_slug: 'SuccessRenewalFlagFlow',
  flow_version: 1,
  uuid: 'auto-renewal-success-page',
  heading: 'Automatic renewal has been updated',
  subtext: '',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Return to dashboard'
  },
  sections: [
    {
      uuid: 'reminder-section-off-success',
      subtext: '',
      layout: '',
      settings: {},
      heading: '',
      info: {
        type: 'warning',
        content: '<h3>Your renewal has been switched off</h3></br><p style="font-weight: normal">Turning your renewal off means your policy won’t renew and you won’t be covered after your policy expires.</p>'
      },
      show_if: {
        operands: [
          '<renewal_flag>',
          [
            'CE',
            'AR'
          ]
        ],
        operator: 'in'
      }
    },
    {
      uuid: 'reminder-section-on-success',
      subtext: '',
      layout: '',
      settings: {},
      heading: '',
      info: {
        type: 'success',
        content: '<h3>Your policy is set to automatically renew</h3></br><p style="font-weight: normal">This means that we’ll automatically renew your policy on your renewal date, if we are able to offer you renewal.</p>'
      },
      show_if: {
        operands: [
          '<renewal_flag>',
          'CD'
        ],
        operator: 'eq'
      }
    }
  ],
  data: {
    _flow_metadata: { current_page_uuid: 'auto-renewal-first' }
  },
  human: {},
  progress: 2,
  total_pages: 2,
  actions: {
    next: {
      label: 'return to dashboard',
      method: 'GET',
      url: 'dashboard/'
    }
  },
  analytics: {
    flow_slug: 'disableRenewalFlow',
    flow_version: 1,
    page_uuid: 'disable-rf-page-one'
  }
};

// UNDEFINED-ERROR
export const AUTO_RENEWAL_ERROR_PAGE = {
  flow_slug: 'RenewalFlagUnsupportedFlow',
  flow_version: 1,
  uuid: 'auto-renewal-error-page',
  heading: 'Manage what happens at renewal',
  subtext: '',
  layout: '',
    settings: {
      align: 'center',
      submit_label: 'Return to dashboard',
    },
  sections: [
    {
      uuid: 'reminder-section-off-success',
      subtext: '',
      layout: '',
      settings: {},
      heading: '',
      info: {
        content: '<h3>Oops! Something went wrong</h3></br><p style="font-weight: normal">Need to update your renewal setting? Chat with one of our friendly agents or try again later.</p>',
        type: 'error'
      },
    }
  ],
  data: {
    _flow_metadata: { current_page_uuid: 'auto-renewal-error-page' }
  },
  human: {},
  actions: {
    back: {},
  },
  progress: 1,
  total_pages: 1,
  analytics: {
    flow_slug: 'RenewalFlagErrorFlow',
    flow_version: 1,
    page_uuid: 'auto-renewal-error-page'
  }
};

export const AUTO_RENEW_FINAL_PAGES: string[] = [
  AUTO_RENEWAL_ERROR_PAGE.flow_slug,
  AUTO_RENEWAL_FLOW_SUCCESS_PAGE.flow_slug,
]

